import React from "react";
import { Link } from "react-router-dom";
import { t } from "../../i18n";
import "./CrossLinks.css";

export default function CrossLinks({ crossLinks, service, location, locale = "en" }) {
  return (
    <section className="cross-links">
      <div className="container">
        <div className="cl-grid">
          <div className="cl-section">
            <h3>{t("section.otherServices", locale, { city: location.city })}</h3>
            <ul>{crossLinks.otherServices.slice(0, 6).map((link, i) => (<li key={i}><Link to={link.path}>{link.label}</Link></li>))}</ul>
          </div>
          <div className="cl-section">
            <h3>{t("section.otherLocations", locale, { service: service.display })}</h3>
            <ul>{crossLinks.otherLocations.slice(0, 6).map((link, i) => (<li key={i}><Link to={link.path}>{link.label}</Link></li>))}</ul>
          </div>
        </div>
      </div>
    </section>
  );
}
